import {CSSProperties, FC} from 'react';


export interface IIconCarAvitoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCarAvito: FC<IIconCarAvitoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21 21"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M5.338 2.5h10a.833.833 0 0 1 .758.492l3.409 7.65V17.5a.833.833 0 0 1-.834.833h-1.666a.833.833 0 0 1-.834-.833v-1.667H4.505V17.5a.833.833 0 0 1-.834.833H2.005a.834.834 0 0 1-.834-.833v-6.858l3.409-7.65a.833.833 0 0 1 .758-.492Zm.542 1.667L4.03 8.333h12.616l-1.85-4.166H5.88Zm2.791 7.5a.833.833 0 1 0 0 1.666h3.334a.833.833 0 1 0 0-1.666H8.67Zm-5.833-.834c0 .46.373.834.833.834h1.667a.833.833 0 0 0 0-1.667H3.671a.833.833 0 0 0-.833.833Zm12.5-.833a.833.833 0 1 0 0 1.667h1.667a.833.833 0 1 0 0-1.667h-1.667Z" />
        </svg>
    );
};
